import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ILocalAGGrid, {
  getDefaultColDef,
  getActionsColumn,
  openAgGridContextMenu,
  actionMenuItem,
} from '../../grid/iLocalAGGrid';
import {
  createAccountResourceDatasource,
  syncGridPageSize,
} from './accountResourceGridUtils';

const ChildrenSortObj = {
  name: { tableName: 'accounts', sortColumn: 'name' },
  type: { tableName: 'account_type', sortColumn: 'type' },
  parent_account: { tableName: 'parent_accounts', sortColumn: 'parent_account' },
};

class AccountChildrenDialog extends React.Component {
  constructor(props) {
    super(props);
    this.filterObj = {
      searchtext: '',
      pageNo: 0,
      pageSize: 10,
      sortOrder: 'desc',
      sortColumn: 'created_on',
      accountId: props.accountId,
    };
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createAccountResourceDatasource({
      filterObj: this.filterObj,
      sortMap: ChildrenSortObj,
      endpoint: 'accounts/children/by/account',
      getAccountId: () => this.props.accountId,
    });
    if (typeof params.api.setServerSideDatasource === 'function') {
      params.api.setServerSideDatasource(datasource);
    }
  };

  onPaginationChanged = (params) => {
    syncGridPageSize(params, this.filterObj);
  };

  openRowActionsMenu = (event, params, menuHelpers) => {
    const items = this.getContextMenuItems(params);
    if (menuHelpers && typeof menuHelpers.openMenu === 'function') {
      menuHelpers.openMenu(items);
      return;
    }
    openAgGridContextMenu(
      params,
      (menuHelpers && menuHelpers.positionEvent) || event
    );
  };

  getContextMenuItems = (params) => {
    const colId =
      params &&
      params.column &&
      (params.column.getColId ? params.column.getColId() : params.column.colId);
    if (colId !== 'actions') return [];
    const row = params.node && params.node.data;
    if (!row) return [];
    const { t, canView, canEdit } = this.props;
    const items = [];
    if (canView) {
      items.push(
        actionMenuItem({
          name: t('Accounts.ViewActions'),
          icon: 'view',
          action: () => this.handleViewAccount(row),
        })
      );
    }
    if (canEdit) {
      items.push(
        actionMenuItem({
          name: t('Accounts.EditActions'),
          icon: 'edit',
          action: () => this.handleEditAccount(row),
        })
      );
    }
    return items;
  };

  handleViewAccount = (selectedObject) => {
    if (!selectedObject || !this.props.onViewAccount) {
      return;
    }
    this.props.onViewAccount(selectedObject);
  };

  handleEditAccount = (selectedObject) => {
    if (!selectedObject || !this.props.onEditAccount) {
      return;
    }
    this.props.onEditAccount(selectedObject);
  };

  render() {
    const { t, canView, canEdit } = this.props;
    const showActions = canView || canEdit;
    const columnDefs = [
      { field: 'name', headerName: t('Accounts.Name') },
      {
        field: 'type',
        headerName: t('Accounts.AccountType'),
        valueGetter: (params) =>
          (params.data && params.data.type && params.data.type.name) || '',
      },
      {
        field: 'parent_account',
        headerName: t('Accounts.ParentAccount'),
        valueGetter: (params) =>
          (params.data && params.data.parent && params.data.parent.name) || '',
      },
      {
        field: 'city',
        headerName: t('Accounts.AccountDetail.City'),
        sortable: false,
        filter: false,
        valueGetter: (params) =>
          (params.data &&
            params.data.contact &&
            params.data.contact.address &&
            params.data.contact.address.city) ||
          '',
      },
    ];
    if (showActions) {
      columnDefs.push(
        getActionsColumn({
          headerName: t('Accounts.Actions'),
          onActionsClick: (event, params, menuHelpers) =>
            this.openRowActionsMenu(event, params, menuHelpers),
        })
      );
    }

    return (
      <ILocalAGGrid
        columnDefs={columnDefs}
        defaultColDef={getDefaultColDef()}
        rowModelType='serverSide'
        cacheBlockSize={this.filterObj.pageSize || 10}
        paginationPageSize={this.filterObj.pageSize || 10}
        paginationPageSizeSelector={[10, 20, 25]}
        rowHeight={45}
        getRowId={(params) => params.data && params.data.id}
        onGridReady={this.onGridReady}
        onPaginationChanged={this.onPaginationChanged}
        getContextMenuItems={this.getContextMenuItems}
        overlayNoRowsMessage={t('Accounts.Terms.NoDataFound')}
      />
    );
  }
}

AccountChildrenDialog.propTypes = {
  accountId: PropTypes.string,
  canView: PropTypes.bool,
  canEdit: PropTypes.bool,
  onViewAccount: PropTypes.func,
  onEditAccount: PropTypes.func,
};

export default withTranslation()(AccountChildrenDialog);



// WEBPACK FOOTER //
// ./src/components/account-list/related/AccountChildrenDialog.js